import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_2 = ["onClick"]


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMenu',
  props: {
  tabs: {
    type: Array,
    required: true,
  },
},
  emits: ["changeTab"],
  setup(__props, { emit }) {

const props = __props;




const isTabActive = (tab: number) => {
  return tab === props.tabs[0].id;
};

const changeTab = (id: number) => {
  emit("changeTab", id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "nav-item",
        key: tab.id
      }, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-4", { active: isTabActive(tab.id) }]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: ($event: any) => (changeTab(tab.id))
        }, _toDisplayString(tab.name), 11, _hoisted_2)
      ]))
    }), 128))
  ]))
}
}

})